import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import RaisedButton from 'material-ui/RaisedButton';
import GoogleLogin from 'react-google-login';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { connect } from 'react-redux';
import * as actions from '../../Actions';

import axios from 'axios';

import { persistor } from '../../Store';

import './Login.css';



const loginButtonStyle = {
  padding: '0px',
  border: 'none'
};


class Login extends Component {

    state = {
        loading: false,
        secretOn: false,
        users: []
    };

    componentWillMount() {

        var field = 'cacique';
        var url = window.location.href;
        if(url.indexOf(field) != -1)
            this.setState({secretOn: true});
        return false


    }

    componentDidMount() {

        axios
        .get('list/users')
        .then(res => this.setState({ users: res.data.users }))
        .catch(err => console.log(err))


    }



    handleDummyChange = (event, index, value) => {
        this.dummyGoogle(value);
    }


    dummyGoogle = (email) => {
        console.log('dummyGoogle ' + email);

        var data = {};
            data.email = email;
            // data.first_name = response.profileObj.givenName;
            // data.last_name = response.profileObj.familyName;
            // data.social_id = response.profileObj.googleId;
            // data.avatar = response.profileObj.imageUrl;

        axios
        .post('auth/google',{
           data: data
        })
        .then(res => {

           this.props.userLogin(res.data.user);
           this.props.tokenLoad(res.data.token);
           this.props.refreshLoad(res.data.refresh);

           document.location.href = '/me/load';

           return true;

        })
        .catch(err => console.log(err));

    }


    responseGoogle = (response) => {
        console.log('responseGoogle')
        console.log(response);

        var data = {};
            data.email = response.profileObj.email;
            data.first_name = response.profileObj.givenName;
            data.last_name = response.profileObj.familyName;
            data.social_id = response.profileObj.googleId;
            data.avatar = response.profileObj.imageUrl;

        axios
        .post('auth/google',{
           data: data
        })
        .then(res => {

           this.props.userLogin(res.data.user);
           this.props.tokenLoad(res.data.token);
           this.props.refreshLoad(res.data.refresh);

           document.location.href = '/me/load';

           return true;

        })
        .catch(err => console.log(err));

    }

    failGoogle = (response) => {
        console.log('failGoogle')
        console.log(response);
    }


    // deprecado porque ya tengo logout por url /me/logout. Igual queda el boton aca, que despues deberia ser link
    logout = () => {
        console.log('logout');

        this.props.userLogout();
        this.props.tokenRelease();
        this.props.refreshRelease();

        this.closeMenu();

        persistor.purge();
    }


    render() {

        const { users, secretOn } = this.state;

        return (
            <div>

                {!this.props.auth.user.id &&
                    <div>
                    {secretOn?
                        <SelectField
                            hintText="Dummy"
                            value={this.state.value}
                            onChange={this.handleDummyChange}
                            className="select-dummy"
                        >
                            {users.map((object) => {
                                return <MenuItem value={object.username} primaryText={object.name} />;
                            })}
                        </SelectField>
                    :
                        <GoogleLogin
                            clientId="527763406040-rhfpde8vr40heh81g001irfhur4vk153.apps.googleusercontent.com"
                            buttonText="Login"
                            onSuccess={this.responseGoogle}
                            onFailure={this.failGoogle}
                            style={loginButtonStyle}
                            className="btn-login"
                        >
                            <a href="#">Ingresar</a>
                        </GoogleLogin>
                    }
                    </div>

                }

            </div>

        );

    };

}


const mapStateToProps = (state) => ({
    auth: state.auth_reducer
});

export default connect(mapStateToProps, actions)(Login);



// WEBPACK FOOTER //
// ./src/containers/Header/Login.js